<ng-container *ngIf="!isShrink" >


  <div class="subscription-container" data-cy="subscription-container" *ngFor="let subscription of ownSubscriptions">
    <a
      class="subscription-wrapper"
      [routerLink]="isStudent ? 'pay' : null"
      [matTooltip]="subscription.serviceName"
      [matTooltipPosition]="'below'"
    >
      <div class="subscription-title">
        <ng-container *ngIf="getTimeUntilExpiration(subscription) as timeLeft; else showDays">
          {{ 'v3.sidebar.subscriptionStatus.expiresIn' | translate : { hours: timeLeft.hours, minutes: timeLeft.minutes } }}
        </ng-container>
        <ng-template #showDays>
          {{ 'v3.sidebar.subscriptionStatus.title' | translate : { days: subscription.availableDays } }}
        </ng-template>
      </div>
      <div class="subscription-progress-outline">
        <div class="subscription-progress-wrapper">
          <div
            class="subscription-progress"
            [style.width.%]="(subscription.availableDays / subscription.term) * 100"
          ></div>
        </div>
      </div>
    </a>

    <a
      *ngIf="userService.user?.canSelfPay"
      data-cy="buy-subscription"
      routerLink="subscriptions/own"
      class="buy-subscription"
      [matTooltip]="subscription.serviceName"
      [matTooltipPosition]="'below'"
    >
      <div class="msi-cart"></div>
    </a>
  </div>

  @if (!ownSubscriptions.length && hasOldSubscriptions && userService.user?.user.accountType !== 'teacher') {
    <div class="subscription-container">
      <div class="subscription-title">
        {{ 'v3.sidebar.subscriptionStatus.hasSubscriptions' | translate }}
      </div>
    </div>
  }

  <div
    class="subscription-container"
    *ngIf="
      !ownSubscriptions.length &&
      (
        userService.user?.user.accountType !== 'student' ||
        userService.user?.canSelfPay
      )
      && userService.user?.user.accountType !== 'teacher'
      && !hasOldSubscriptions
    "
  >
    <a
      class="subscription-wrapper"
    >
      <div class="subscription-title">
        {{ 'v3.sidebar.subscriptionStatus.noSubscriptions' | translate }}
      </div>
    </a>

    <a
      data-cy="empty-buy-subscription"
      routerLink="subscriptions/own"
      class="buy-subscription"
    >
      <div class="msi-cart"></div>
    </a>
  </div>


</ng-container>

<ng-container *ngIf="isShrink">
  <div
    class="subscription-container"
    *ngIf="userService.user?.canSelfPay"
  >
    <a
      data-cy="shrink-buy-subscription"
      routerLink="subscriptions/own"
      class="buy-subscription buy-subscription--shrink"
    >
      <div class="msi-cart"></div>
    </a>
  </div>
</ng-container>
